import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { SessionEndReason, SessionStartPayload } from "./auth.model";

export const ACTION_PREFIX = "[Auth]";
/**
 * This model will be removed as part of FEVO project and only @obg/contracts/auth will stay
 */
export const AUTH_ACTION_TYPE = {
	/**
	 * User session has started or resumed on token verification
	 * Should be used in consumer effects to trigger actions/side effects when user gets logged in, verified, etc
	 */
	sessionStart: `${ACTION_PREFIX} Session start ${SYNC_SUFFIX}`,
	/**
	 * User session has ended or it failed to start.
	 * Should be used in consumer effects to trigger actions/side effects when user logs out, session times out, etc.
	 */
	sessionEnd: `${ACTION_PREFIX} Session end ${SYNC_SUFFIX}`,

	logout: `${ACTION_PREFIX} Logout ${SYNC_SUFFIX}`,

	/**
	 * manual keeping alive of the current session
	 */
	keepAlive: `${ACTION_PREFIX} Keep Alive ${SYNC_SUFFIX}`,
};

/**
 * This action will be removed as part of FEVO project and only @obg/contracts/auth will stay
 */
@Injectable({
	providedIn: "root",
})
export class AuthAction {
	sessionStart(data: SessionStartPayload): ActionWithPayload {
		return {
			type: AUTH_ACTION_TYPE.sessionStart,
			payload: data,
		};
	}

	sessionEnd(reason?: SessionEndReason): ActionWithPayload {
		return {
			type: AUTH_ACTION_TYPE.sessionEnd,
			payload: reason,
		};
	}

	logout(): Action {
		return {
			type: AUTH_ACTION_TYPE.logout,
		};
	}

	keepAlive(): Action {
		return {
			type: AUTH_ACTION_TYPE.keepAlive,
		};
	}
}
